var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hamburger hamburger--elastic",attrs:{"type":"button","aria-label":"Menu","aria-controls":"navigation","aria-expanded":"false"}},[_c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])])
}]

export { render, staticRenderFns }